<template>
  <div>
    <Form :label-width="150">
      <!-- 基本信息 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.basicinformationhosteddatabase' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )">
                  <span style="width: 200px;">{{accountTypeSearchKey}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.account' )">
                  <span style="width: 200px;">{{accountId}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.area' )">
                  <span style="width: 200px;">{{region}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.uses' )">
                  <span style="width: 200px;">{{use}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.periodofuse' )">
                  <span style="width: 200px;">{{periodOfUse}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceType' )">
                  <span style="width: 200px;">{{resourceType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.environment' )">
                  <span style="width: 200px;">{{environment}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.flow' )">
                  <span style="width: 200px;">{{approvalFlow}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- 资源配置 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourceConfiguration' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseName' )">
                  <span style="width: 200px;">{{databaseName}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseEngine' )">
                  <span style="width: 200px;">{{databaseEngine}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseVersion' )">
                  <span style="width: 200px;">{{databaseVersion}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseEngineVersion' )">
                  <span style="width: 200px;">{{databaseEngineVersion}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.dBInstanceClass' )">
                  <span style="width: 200px;">{{databaseInstanceClass}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.multiAZDeployment' )">
                  <span style="width: 200px;">{{multiAZDeployment}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.allottedstorage' )">
                  <span style="width: 200px;">{{allocatedStorageSpace}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.storageType' )">
                  <span style="width: 200px;">{{storageType}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.presetIOPS' )">
                  <span style="width: 200px;">{{presetIOPS}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.masterUsername' )">
                  <span style="width: 200px;">{{masterUsername}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.masterPassword' )">
                  <span style="width: 200px;">******</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.ports' )">
                  <span style="width: 200px;">{{port}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseParameterGroups' )">
                  <span style="width: 200px;">{{databaseParameterGroup}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.optionGroups' )">
                  <span style="width: 200px;">{{optionGroup}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.iAMDatabaseAuthentication' )">
                  <span style="width: 200px;">{{iamDatabaseAuthentication}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem label="VPC:">
                  <span style="width: 200px;">{{vpc}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.subnetGroup' )">
                  <span style="width: 200px;">{{subnetGroup}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.publicAvailability' )">
                  <span style="width: 200px;">{{publicAvailability}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.availabilityZone' )">
                  <span style="width: 200px;">{{availabilityZone}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.vPCSecurityGroup' )">
                  <span style="width: 200px;">{{vpcSecurityGroup}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.existingSecurityGroups' )">
                  <span style="width: 200px;">{{existingSecurityGroup}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.copylabelforsnapshot' )">
                  <span style="width: 200px;">{{copyTagsToSnapshot}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.enabledeleteprotection' )">
                  <span style="width: 200px;">{{enableDeleteProtection}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem prop="enclosure" :label="$t( 'resourceLifecycle.exhibits' )">
                  <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                    <template slot-scope="{row,index}" slot="download">
                      <!-- 下载 -->
                      <Button type="success" :loading="modal_loadings" size="small" @click="downloadFile(row)">
                        {{$t('resourceLifecycle.download')}}</Button>
                    </template>
                  </Table>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.remarkation' )">
                  <span style="width: 200px;">{{describe}}</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.estimatedcost' )">
                  <span style="width: 200px;">{{cost}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
  export default {
    name: 'AmazonVirtualMachineDetail',
    props: ['amazonResourceApplicationBasicInfoForm'],
    data () {
      return {
        modal_loadings: false,//下载
        accountTypeSearchKey:'',
        accountId:'',
        region:'',
        use:'',
        periodOfUse:'',
        resourceType:'',
        environment:'',
        approvalFlow:'',
        databaseName:'',
        databaseEngine:'',
        databaseEngineVersion:'',
        databaseInstanceClass:'',
        multiAZDeployment:'',
        storageType:'',
        allocatedStorageSpace:'',
        presetIOPS:'',
        masterUsername:'',
        password:'',
        port:'',
        databaseParameterGroup:'',
        optionGroup:'',
        iamDatabaseAuthentication:'',
        vpc:'',
        describe:'',
        subnetGroup:'',
        publicAvailability:'',
        availabilityZone:'',
        vpcSecurityGroup:'',
        existingSecurityGroup:'',
        copyTagsToSnapshot: '',
        enableDeleteProtection:'',
        databaseVersion:'',
        cost:'',
        columnsFile: [
          {
            title: this.$t( 'resourceLifecycle.filenames' ),
            key: 'fileName'
          },
          {
            title: this.$t( 'resourceLifecycle.fileType' ),
            key: 'fileType'
          },
          {
            title: this.$t('common.operation'),
            slot: 'download',
            "width": 100
          }],
        fileData:[]
      }
    },
    mounted: function () {
      this.dealWithLine();
    },
    methods: {
      // 处理
      /****************************************************/
      dealWithLine: function(){
        // 审批
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id":this.amazonResourceApplicationBasicInfoForm.id
        })
          .then(res => {
            // Common Params
            this.accountTypeSearchKey = res.data.platformString;
            this.accountId = res.data.accountName;
            this.region = res.data.region;
            this.use = res.data.usageNote;
            this.periodOfUse = res.data.duration + this.$t( 'resourceLifecycle.months' );
            this.resourceType = res.data.lifecycleResourceTypeDesc;
            this.environment = res.data.environmentDesc;
            this.approvalFlow = res.data.approvalFlow;
            this.describe = res.data.remark;
            this.cost = res.data.cost;
            if (res.data.attachmentList != null && res.data.attachmentList != undefined && res.data.attachmentList.length > 0){
              this.fileData = res.data.attachmentList;
            }

            // DatabaseDTO
            this.databaseName = res.data.lifecycleResourceAwsDatabaseDTO.databaseId;
            this.databaseEngine = res.data.lifecycleResourceAwsDatabaseDTO.engine;
            this.databaseVersion = res.data.lifecycleResourceAwsDatabaseDTO.versions;
            this.databaseEngineVersion = res.data.lifecycleResourceAwsDatabaseDTO.engineVersion;
            this.databaseInstanceClass = res.data.lifecycleResourceAwsDatabaseDTO.databaseInstanceClassName;
            this.multiAZDeployment = res.data.lifecycleResourceAwsDatabaseDTO.multiAZ == true ? this.$t( 'resourceLifecycle.yes' ) : this.$t( 'resourceLifecycle.no' );
            this.allocatedStorageSpace = res.data.lifecycleResourceAwsDatabaseDTO.allocatedStorage + "G";
            this.storageType = res.data.lifecycleResourceAwsDatabaseDTO.storageType;
            this.presetIOPS = res.data.lifecycleResourceAwsDatabaseDTO.iops;
            this.masterUsername = res.data.lifecycleResourceAwsDatabaseDTO.masterUsername;
            this.password = res.data.lifecycleResourceAwsDatabaseDTO.masterUserPassword;
            this.port = res.data.lifecycleResourceAwsDatabaseDTO.port;
            this.databaseParameterGroup = res.data.lifecycleResourceAwsDatabaseDTO.dbParameterGroupName;
            this.optionGroup = res.data.lifecycleResourceAwsDatabaseDTO.optionGroupName;
            this.iamDatabaseAuthentication = res.data.lifecycleResourceAwsDatabaseDTO.enableIAMDatabaseAuthentication == true ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
            this.vpc = res.data.lifecycleResourceAwsDatabaseDTO.vpcId;
            this.subnetGroup = res.data.lifecycleResourceAwsDatabaseDTO.dbSubnetGroupName;
            this.publicAvailability = res.data.lifecycleResourceAwsDatabaseDTO.publiclyAccessible == true ? this.$t( 'resourceLifecycle.yes' ) : this.$t( 'resourceLifecycle.no' );
            this.availabilityZone = res.data.lifecycleResourceAwsDatabaseDTO.availabilityZone;
            this.vpcSecurityGroup = res.data.lifecycleResourceAwsDatabaseDTO.vpcGroup == true ? this.$t( 'resourceLifecycle.createanewVPCsecuritygroup' ) : this.$t( 'resourceLifecycle.selectanexistingVPCsecuritygroup' );

            if (res.data.lifecycleResourceAwsDatabaseDTO.vpcSecurityGroupIdName != null && res.data.lifecycleResourceAwsDatabaseDTO.vpcSecurityGroupIdName != '' && res.data.lifecycleResourceAwsDatabaseDTO.vpcSecurityGroupIdName != undefined){
              this.existingSecurityGroup = res.data.lifecycleResourceAwsDatabaseDTO.vpcSecurityGroupIdName;
            }
            this.copyTagsToSnapshot = res.data.lifecycleResourceAwsDatabaseDTO.copyTagsToSnapshot == true ? this.$t( 'resourceLifecycle.yes' ) : this.$t( 'resourceLifecycle.no' );
            this.enableDeleteProtection = res.data.lifecycleResourceAwsDatabaseDTO.enableDeleteProtection == true ?this.$t( 'resourceLifecycle.yes' ) : this.$t( 'resourceLifecycle.no' );

          })
      },
      // 下载附件
      /************************************************************/
      downloadFile: function(row){
        // 下载附件
        this.modal_loadings = true;
        this.$api.file.downloadFile("id",row.id)
          .then(res => {
            let aTag = document.createElement('a');
            let blob = new Blob([res.data],{type: 'text/plain;charset=UTF-8'})
            aTag.download = row.fileName;
            aTag.href = URL.createObjectURL(blob);
            aTag.click();
            URL.revokeObjectURL(blob);
            setTimeout(() => {
              this.modal_loadings = false;
              this.$Message.success(this.$t( 'resourceLifecycle.response.downloadSuccess' ));
            }, 1000);
          })
      }
    }
  }
</script>

<style scoped>
  .ivu-form-item {
    margin-bottom: 0px !important;
    vertical-align: top;
    zoom: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabaseDetail.vue